__turbopack_context__.v({
  "container": "PreOrderAttendeesCountTag-module-scss-module__oWyMoW__container",
});
